'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = require('./ApiError');

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Debug = require('../util/Debug');

var _Debug2 = _interopRequireDefault(_Debug);

var _Env = require('../util/Env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var qa = (0, _Env.isQa)() ? 'qa' : '';
var HUBLYTICS_URL = '//api.hubspot' + qa + '.com/usage-logging/v1/log/hublytics-multi/no-auth';

var HublyticsApi = function () {
  function HublyticsApi() {
    _classCallCheck(this, HublyticsApi);
  }

  _createClass(HublyticsApi, [{
    key: 'postEvent',
    value: function postEvent(event, clientSendTimestamp) {
      var httpRequest = new XMLHttpRequest();

      if (!httpRequest) {
        throw "Could not create XMLHttpRequest. Browser may not support AJAX.";
      }

      var requestHandler = function requestHandler() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            (0, _Debug2.default)('Logged hublytics event', event.what_event);
          } else {
            console.error('Failed to post to hublytics Api', new _ApiError2.default(httpRequest));
          }
        }
      };

      httpRequest.onreadystatechange = requestHandler;
      httpRequest.open('POST', HUBLYTICS_URL + '?clientSendTimestamp=' + clientSendTimestamp);
      httpRequest.setRequestHeader('Accept', 'application/json, text/javascript');
      httpRequest.setRequestHeader('Content-type', 'application/json');
      httpRequest.send(JSON.stringify([event]));

      return true;
    }
  }]);

  return HublyticsApi;
}();

exports.default = new HublyticsApi();
module.exports = exports['default'];